import { Box, IconButton, Stack, Typography } from "@mui/material";
import { useState } from "react";

import { ScreenLocationOption } from "../modals/CreateRuleModal";
import ScreenLocationPreviewEyeIcon from "../modals/ScreenLocationPreviewEyeIcon";
import ScreenLocationPreviewModal from "../modals/ScreenLocationPreviewModal";
import type { ReactionLocationRuleNode, RuleNodeProps } from "../types/nodes";
import { normalizeLocationPreviewImageUrl } from "../utils/normalization-utils";
import BaseNode from "./BaseNode";

type ReactionLocationNodeProps = RuleNodeProps<ReactionLocationRuleNode>;

const ReactionLocationNode = (props: ReactionLocationNodeProps) => {
	const { data } = props;
	const [locationPreviewOpen, setLocationPreviewOpen] = useState(false);
	const [locationPreviewUrl, setLocationPreviewUrl] = useState("");
	const [locationPreviewName, setLocationPreviewName] = useState("");
	
	const previewUrl = normalizeLocationPreviewImageUrl(data as unknown as ScreenLocationOption);

	return (
		<>
			<BaseNode {...props}>
				<>
					<Box
						sx={{
							position: "absolute",
							top: (theme) => theme.spacing(0.5),
							right: (theme) => theme.spacing(0.5),
							zIndex: 2,
						}}
					>
						<IconButton
							size="small"
							disabled={!previewUrl}
							aria-label={previewUrl ? `Preview ${data.screenLocation}` : "Preview unavailable"}
							className="nodrag"
							onMouseDown={(event) => {
								event.stopPropagation();
							}}
							onClick={(event) => {
								event.stopPropagation();
								event.preventDefault();
								if (previewUrl) {
									setLocationPreviewUrl(previewUrl);
									setLocationPreviewName(data.screenLocation);
									setLocationPreviewOpen(true);
								}
							}}
							sx={{
								color: previewUrl ? "#1890FF" : "text.disabled",
							}}
						>
							<ScreenLocationPreviewEyeIcon />
						</IconButton>
					</Box>
					<Stack spacing={0.5}>
						<Stack direction="row" spacing={0.5} alignItems="baseline" flexWrap="wrap">
							<Typography variant="body2" color="text.secondary" fontWeight={600}>
								Name:
							</Typography>
							<Typography variant="body2" color="text.primary">
								{data.screenLocation}
							</Typography>
						</Stack>
					</Stack>
				</>
			</BaseNode>
			<ScreenLocationPreviewModal
				open={locationPreviewOpen}
				onClose={() => {
					setLocationPreviewOpen(false);
					setLocationPreviewUrl("");
					setLocationPreviewName("");
				}}
				previewUrl={locationPreviewUrl}
				locationName={locationPreviewName}
				stackingOffset={10}
			/>
		</>
	);
};

export default ReactionLocationNode;
